import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6f50bcae from 'nuxt_plugin_plugin_6f50bcae' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_dc50521a from 'nuxt_plugin_bootstrapvue_dc50521a' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_newgeoportalplugin07d82566_103cc671 from 'nuxt_plugin_newgeoportalplugin07d82566_103cc671' // Source: ./new_geoportal.plugin.07d82566.js (mode: 'all')
import nuxt_plugin_AstanaEgknplugin6d2eab4e_e31b8b86 from 'nuxt_plugin_AstanaEgknplugin6d2eab4e_e31b8b86' // Source: ./AstanaEgkn.plugin.6d2eab4e.js (mode: 'all')
import nuxt_plugin_pluginutils_c5cddc12 from 'nuxt_plugin_pluginutils_c5cddc12' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_711cfd82 from 'nuxt_plugin_pluginrouting_711cfd82' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2a42a5a6 from 'nuxt_plugin_pluginmain_2a42a5a6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_nuxtvueselect_34cd6c26 from 'nuxt_plugin_nuxtvueselect_34cd6c26' // Source: ./nuxt-vue-select.js (mode: 'client')
import nuxt_plugin_axios_24d40678 from 'nuxt_plugin_axios_24d40678' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuefinalmodal_c72228ce from 'nuxt_plugin_vuefinalmodal_c72228ce' // Source: ../uicore/plugins/vue-final-modal (mode: 'all')
import nuxt_plugin_vuepagination_16ae9f37 from 'nuxt_plugin_vuepagination_16ae9f37' // Source: ../uicore/plugins/vue-pagination (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../uicore/plugins/axios (mode: 'all')
import nuxt_plugin_vuescrollactive_96ef6720 from 'nuxt_plugin_vuescrollactive_96ef6720' // Source: ../uicore/plugins/vue-scrollactive (mode: 'all')
import nuxt_plugin_vuemask_9dbcaf6e from 'nuxt_plugin_vuemask_9dbcaf6e' // Source: ../uicore/plugins/vue-mask (mode: 'all')
import nuxt_plugin_persistentpagination_6780aada from 'nuxt_plugin_persistentpagination_6780aada' // Source: ../uicore/plugins/persistent-pagination (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../uicore/plugins/i18n (mode: 'all')
import nuxt_plugin_gojs_6a80f0a7 from 'nuxt_plugin_gojs_6a80f0a7' // Source: ../uicore/plugins/gojs (mode: 'all')
import nuxt_plugin_vuejsonexcel_a434eb30 from 'nuxt_plugin_vuejsonexcel_a434eb30' // Source: ../uicore/plugins/vue-json-excel.js (mode: 'all')
import nuxt_plugin_auth_5df903ec from 'nuxt_plugin_auth_5df903ec' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Система","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6f50bcae === 'function') {
    await nuxt_plugin_plugin_6f50bcae(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_dc50521a === 'function') {
    await nuxt_plugin_bootstrapvue_dc50521a(app.context, inject)
  }

  if (typeof nuxt_plugin_newgeoportalplugin07d82566_103cc671 === 'function') {
    await nuxt_plugin_newgeoportalplugin07d82566_103cc671(app.context, inject)
  }

  if (typeof nuxt_plugin_AstanaEgknplugin6d2eab4e_e31b8b86 === 'function') {
    await nuxt_plugin_AstanaEgknplugin6d2eab4e_e31b8b86(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c5cddc12 === 'function') {
    await nuxt_plugin_pluginutils_c5cddc12(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_711cfd82 === 'function') {
    await nuxt_plugin_pluginrouting_711cfd82(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2a42a5a6 === 'function') {
    await nuxt_plugin_pluginmain_2a42a5a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvueselect_34cd6c26 === 'function') {
    await nuxt_plugin_nuxtvueselect_34cd6c26(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_24d40678 === 'function') {
    await nuxt_plugin_axios_24d40678(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefinalmodal_c72228ce === 'function') {
    await nuxt_plugin_vuefinalmodal_c72228ce(app.context, inject)
  }

  if (typeof nuxt_plugin_vuepagination_16ae9f37 === 'function') {
    await nuxt_plugin_vuepagination_16ae9f37(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_vuescrollactive_96ef6720 === 'function') {
    await nuxt_plugin_vuescrollactive_96ef6720(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_9dbcaf6e === 'function') {
    await nuxt_plugin_vuemask_9dbcaf6e(app.context, inject)
  }

  if (typeof nuxt_plugin_persistentpagination_6780aada === 'function') {
    await nuxt_plugin_persistentpagination_6780aada(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_gojs_6a80f0a7 === 'function') {
    await nuxt_plugin_gojs_6a80f0a7(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsonexcel_a434eb30 === 'function') {
    await nuxt_plugin_vuejsonexcel_a434eb30(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_5df903ec === 'function') {
    await nuxt_plugin_auth_5df903ec(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
